import {
  campaignTitleParamName,
  moduleOriginParamName,
} from '../activityTracker/constants';
import { type MarketingBannerData } from '../cms/helpers/assertions/marketingBanner';
import { type HomepageModuleTile } from '../cms/types';
import { appendParams } from '../routing/appendParams/appendParams';
import { toSnakeCase } from '../text/helpers';

import {
  VARIANT_A_IDENTIFIER,
  VARIANT_B_IDENTIFIER,
} from '@/modules/experiments/config';

/**
 * Returns the appropriate image based on the experiment variant for web_7707_broaden_appeal_imagery
 */
export function getCMSImageForVariant(
  tile: Pick<HomepageModuleTile, 'image' | 'image2' | 'image3'>,
  experimentVariant: string | undefined
) {
  if (experimentVariant === VARIANT_A_IDENTIFIER && tile.image2) {
    return tile.image2;
  }
  if (experimentVariant === VARIANT_B_IDENTIFIER && tile.image3) {
    return tile.image3;
  }
  return tile.image;
}

type BannerWithImages = Pick<
  MarketingBannerData[number],
  | 'mobileBackgroundImageUrl'
  | 'mobileBackgroundImageUrl2'
  | 'mobileBackgroundImageUrl3'
  | 'desktopBackgroundImageUrl'
  | 'desktopBackgroundImageUrl2'
  | 'desktopBackgroundImageUrl3'
>;

/**
 * Returns the appropriate mobile and desktop banner images based on the experiment variant for web_7707_broaden_appeal_imagery
 */
export function getBannerImagesForVariant(
  banner: BannerWithImages,
  experimentVariant: string | undefined
): { mobileImageUrl: string; desktopImageUrl: string } {
  if (experimentVariant === VARIANT_A_IDENTIFIER) {
    return {
      mobileImageUrl:
        banner.mobileBackgroundImageUrl2 || banner.mobileBackgroundImageUrl,
      desktopImageUrl:
        banner.desktopBackgroundImageUrl2 || banner.desktopBackgroundImageUrl,
    };
  }
  if (experimentVariant === VARIANT_B_IDENTIFIER) {
    return {
      mobileImageUrl:
        banner.mobileBackgroundImageUrl3 || banner.mobileBackgroundImageUrl,
      desktopImageUrl:
        banner.desktopBackgroundImageUrl3 || banner.desktopBackgroundImageUrl,
    };
  }
  return {
    mobileImageUrl: banner.mobileBackgroundImageUrl,
    desktopImageUrl: banner.desktopBackgroundImageUrl,
  };
}

export function createCMSTileHref(
  tile: {
    link: string;
    title: string;
  },
  moduleOrigin: string
) {
  return appendParams(
    tile.link,
    [moduleOriginParamName, moduleOrigin],
    [campaignTitleParamName, toSnakeCase(tile.title)]
  );
}
